module.exports = "<app-admin-nav></app-admin-nav>\n\n"